const menu = document.querySelector('[data-behaviour="menu"]');
const menuToggle = document.querySelector('[data-behaviour="menu-button"]');

if (menu && menuToggle) {
    
    menuToggle.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.toggle("menu-is-open");
    });

}